// import { colors, space, radius, fontSize } from "../../design/tokens";


// export default function TextInput({ style, slim, label, error, ...props }) {
//   return (
//     <div style={{ display: "flex", flexDirection: "column", gap: space.xs }}>
//       {label && (
//         <label style={{ fontSize: fontSize.xs, color: colors.text, alignSelf: "center" }}>
//           {label}
//         </label>
//       )}
//       <input
//         style={{
//           width: "100%",

//           background: colors.surface,

//           border: "none",
//           borderBottom: "",
//           outline: "none",

//           borderRadius: slim ? radius.lg : radius.xl,

//           padding: slim ? space.sm : space.lg,

//           fontSize: slim ? fontSize.sm : fontSize.md,
//           color: colors.text,

//           ...style,
//         }}
//         {...props}
//       />
//       <div style={{ fontSize: fontSize.xs, color: colors.error, alignSelf: "center"  }}>
//         {error}
//       </div>
//     </div>
//   );
// }

import { colors, space, radius, fontSize } from "../../design/tokens";
import { forwardRef } from "react";

const TextInput = forwardRef(({ style, slim, label, error, ...props }, ref) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: space.xs }}>
      {label && (
        <label style={{ fontSize: fontSize.xs, color: colors.text, alignSelf: "center" }}>
          {label}
        </label>
      )}
      <input
        ref={ref}
        style={{
          width: "100%",
          background: colors.surface,
          border: "none",
          borderBottom: "",
          outline: "none",
          borderRadius: slim ? radius.lg : radius.xl,
          padding: slim ? space.sm : space.lg,
          fontSize: slim ? fontSize.sm : fontSize.md,
          color: colors.text,
          ...style,
        }}
        {...props}
      />
      {error && (<div style={{ fontSize: fontSize.xs, color: colors.error, alignSelf: "center" }}>
        {error}
      </div>)}
    </div>
  );
});

export default TextInput;